module.exports = __webpack_public_path__ + "static/media/interactive_timesheet.aa65b692.svg";